import { handleActions } from "redux-actions";
import {
    setSelectedBranches,
    getBranches,
    getBranchesSuccess,
    getBranchesError,
    getBranchByCode,
    getBranchByCodeSuccess,
    getBranchByCodeError,
    updateBranch,
    updateBranchError,
    updateBranchSuccess,
    updateBranchPartially,
    updateBranchPartiallySuccess,
    updateBranchPartiallyError,
    clearBranches,
    createBranch,
    createBranchSuccess,
    createBranchError,
} from "modules/Branches/services/Branches/actions";

const initialState = {
    isLoading: false,
    codes: [],
    branches: [],
    branch: {},
    selectedBranches: [],
    count: 0,
};

export const branchesEntriesReducer = handleActions(
    {
        [clearBranches]: () => ({ ...initialState }),
        [getBranches]: (state) => ({
            ...state,
            codes: [],
            branches: [],
            selectedBranches: [],
            isLoading: true
        }),
        [getBranchesSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getBranchesError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [getBranchByCode]: (state) => ({
            ...state,
            isLoading: true
        }),
        [getBranchByCodeSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            branch: payload
        }),
        [getBranchByCodeError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [createBranch]: (state) => ({
            ...state,
            isLoading: true
        }),
        [createBranchSuccess]: (state) => ({
            ...state,
            isLoading: false
        }),
        [createBranchError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [updateBranch]: (state) => ({
            ...state,
            isLoading: true
        }),
        [updateBranchSuccess]: (state) => ({
            ...state,
            isLoading: false
        }),
        [updateBranchError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [updateBranchPartially]: (state) => ({
            ...state,
            isLoading: true
        }),
        [updateBranchPartiallySuccess]: (state, { payload }) => {
            const newBranches = { ...state.branches };
            newBranches[payload.code] = payload;
            return {
                ...state,
                isLoading: false,
                branches: newBranches
            };
        },
        [updateBranchPartiallyError]: (state) => ({
            ...state,
            isLoading: false
        }),
        [setSelectedBranches]: (state, { payload }) => ({
            ...state,
            selectedBranches: payload
        }),
    },
    initialState
);
